import HeaderMapper from './header-mapper';
import CategoryModel from '../category/category-model';
import LeagueModel from '../league/league-model';

const HeaderModel = {
    mapper: HeaderMapper,

    categories: {
        model: CategoryModel,
        type: Array,
    },

    leagues: {
        model: LeagueModel,
        type: Array,
    },
};

export default HeaderModel;
